export enum LogoOptions {
  Custom = 'custom',
  DefaultColored = 'default colored',
  DefaultBW = 'default bw',
  Partnership = 'partnership',
}
export type PartnerLogo = {
  id: number;
  imageSrc: string;
  alt: string;
};

export enum LogoDimensions {
  width = 288,
  height = 180,
}
